"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SlotMachine;
require("core-js/modules/es.array.flat.js");
require("core-js/modules/es.array.unscopables.flat.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _carousel = _interopRequireDefault(require("../carousel"));
var _wheelFrame = _interopRequireDefault(require("../wheel-frame"));
var _playbutton = require("../../assets/playbutton.svg");
var _addbutton = require("../../assets/addbutton.svg");
var _start_block_category = require("../../assets/block-categories/start_block_category.svg");
var _ontouchcog = require("../../assets/blocks/event/ontouchcog.svg");
var _onshake = require("../../assets/blocks/event/onshake.svg");
var _ontiltleft = require("../../assets/blocks/event/ontiltleft.svg");
var _ontiltright = require("../../assets/blocks/event/ontiltright.svg");
var _ontiltforward = require("../../assets/blocks/event/ontiltforward.svg");
var _ontiltbackward = require("../../assets/blocks/event/ontiltbackward.svg");
var _look_block_category = require("../../assets/block-categories/look_block_category.svg");
var _rainbow = require("../../assets/blocks/looks/rainbow.svg");
var _clearcolors = require("../../assets/blocks/looks/clearcolors.svg");
var _red = require("../../assets/blocks/looks/red.svg");
var _green = require("../../assets/blocks/looks/green.svg");
var _blue = require("../../assets/blocks/looks/blue.svg");
var _purple = require("../../assets/blocks/looks/purple.svg");
var _yellow = require("../../assets/blocks/looks/yellow.svg");
var _orange = require("../../assets/blocks/looks/orange.svg");
var _sound_block_category = require("../../assets/block-categories/sound_block_category.svg");
var _no = require("../../assets/blocks/sound/no.svg");
var _noway = require("../../assets/blocks/sound/noway.svg");
var _excitement = require("../../assets/blocks/sound/excitement.svg");
var _disbelief = require("../../assets/blocks/sound/disbelief.svg");
var _confusion = require("../../assets/blocks/sound/confusion.svg");
var _whistle = require("../../assets/blocks/sound/whistle.svg");
var _react = require("react");
var _slotMachineContext = _interopRequireDefault(require("../../store/slot-machine-context"));
var _Executor = require("../../utils/Executor");
var _ModalState = _interopRequireDefault(require("../../modal/ModalState"));
var _wheelSelectorModal = _interopRequireDefault(require("../modals/wheel-selector-modal"));
var _connection = _interopRequireDefault(require("../../connection"));
var _raftSubscriptionHelpers = require("../../utils/raft-subscription-helpers");
var _raft = require("@robotical/webapp-types/dist-types/src/types/raft");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const repeat = (n, array) => {
  /* Repeats every element in the array until the array length = n */
  return Array(n).fill(array).flat().slice(0, n);
};
const eventPosterItems = repeat(12, [{
  icon: _onshake.ReactComponent,
  block: "onshake",
  execute: _Executor.EventBlocksExecutor.onShake
}, {
  icon: _ontiltleft.ReactComponent,
  block: "ontiltleft",
  execute: _Executor.EventBlocksExecutor.onTiltLeft
}, {
  icon: _ontiltright.ReactComponent,
  block: "ontiltright",
  execute: _Executor.EventBlocksExecutor.onTiltRight
}, {
  icon: _ontiltbackward.ReactComponent,
  block: "ontiltbackwards",
  execute: _Executor.EventBlocksExecutor.onTiltBackwards
}, {
  icon: _ontiltforward.ReactComponent,
  block: "ontiltforwards",
  execute: _Executor.EventBlocksExecutor.onTiltForwards
}, {
  icon: _ontouchcog.ReactComponent,
  block: "ontouchcog",
  execute: _Executor.EventBlocksExecutor.onTouchCog
}]);
const lookPosterItems = repeat(12, [{
  icon: _rainbow.ReactComponent,
  block: "patternrainbow",
  execute: _Executor.LookBlocksExecutor.patternRainbow
}, {
  icon: _clearcolors.ReactComponent,
  block: "clearcolors",
  execute: _Executor.LookBlocksExecutor.setColorLED.bind(null, "000000")
}, {
  icon: _red.ReactComponent,
  block: "selectcolorred",
  execute: _Executor.LookBlocksExecutor.setColorLED.bind(null, "ff0000")
}, {
  icon: _green.ReactComponent,
  block: "selectcolorgreen",
  execute: _Executor.LookBlocksExecutor.setColorLED.bind(null, "00ff00")
}, {
  icon: _blue.ReactComponent,
  block: "selectcolorblue",
  execute: _Executor.LookBlocksExecutor.setColorLED.bind(null, "0000ff")
}, {
  icon: _purple.ReactComponent,
  block: "selectcolorpurple",
  execute: _Executor.LookBlocksExecutor.setColorLED.bind(null, "ff00ff")
}, {
  icon: _yellow.ReactComponent,
  block: "selectcoloryellow",
  execute: _Executor.LookBlocksExecutor.setColorLED.bind(null, "ffff00")
}, {
  icon: _orange.ReactComponent,
  block: "selectcolororange",
  execute: _Executor.LookBlocksExecutor.setColorLED.bind(null, "ff7700")
}]);
const soundPosterItems = repeat(12, [{
  icon: _no.ReactComponent,
  block: "no",
  execute: _Executor.SoundBlocksExecutor.playSound.bind(null, "no")
}, {
  icon: _noway.ReactComponent,
  block: "noway",
  execute: _Executor.SoundBlocksExecutor.playSound.bind(null, "noway")
}, {
  icon: _disbelief.ReactComponent,
  block: "disbelief",
  execute: _Executor.SoundBlocksExecutor.playSound.bind(null, "disbelief")
}, {
  icon: _confusion.ReactComponent,
  block: "confusion",
  execute: _Executor.SoundBlocksExecutor.playSound.bind(null, "confusion")
}, {
  icon: _excitement.ReactComponent,
  block: "excitement",
  execute: _Executor.SoundBlocksExecutor.playSound.bind(null, "excitement")
}, {
  icon: _whistle.ReactComponent,
  block: "whistle",
  execute: _Executor.SoundBlocksExecutor.playSound.bind(null, "whistle")
}]);
function SlotMachine() {
  const slotMachineContext = (0, _react.useContext)(_slotMachineContext.default);
  const [connectedCog, setConnectedCog] = (0, _react.useState)(null);
  const subHelper = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    var _window$applicationMa;
    /* Checks if we are already connected to a cog */
    const selectedCog = (_window$applicationMa = window.applicationManager) === null || _window$applicationMa === void 0 ? void 0 : _window$applicationMa.getTheCurrentlySelectedDeviceOrFirstOfItsKind(_raft.RaftTypeE.COG);
    if (selectedCog) {
      setConnectedCog(selectedCog);
      subHelper.current = (0, _raftSubscriptionHelpers.raftDisconnectedSubscriptionHelper)(selectedCog);
      subHelper.current.subscribe(() => {
        var _subHelper$current;
        setConnectedCog(null);
        (_subHelper$current = subHelper.current) === null || _subHelper$current === void 0 || _subHelper$current.unsubscribe();
      });
    }
    return () => {
      var _subHelper$current2;
      (_subHelper$current2 = subHelper.current) === null || _subHelper$current2 === void 0 || _subHelper$current2.unsubscribe();
    };
  }, []);
  const handleConnect = () => {
    var _window$applicationMa2;
    (_window$applicationMa2 = window.applicationManager) === null || _window$applicationMa2 === void 0 || _window$applicationMa2.connectGenericCog(raft => {
      setConnectedCog(raft);
      subHelper.current = (0, _raftSubscriptionHelpers.raftDisconnectedSubscriptionHelper)(raft);
      subHelper.current.subscribe(() => {
        var _subHelper$current3;
        setConnectedCog(null);
        (_subHelper$current3 = subHelper.current) === null || _subHelper$current3 === void 0 || _subHelper$current3.unsubscribe();
      });
    });
  };
  const handleDisconnect = () => {
    if (connectedCog) {
      var _window$applicationMa3;
      (_window$applicationMa3 = window.applicationManager) === null || _window$applicationMa3 === void 0 || _window$applicationMa3.disconnectGeneric(connectedCog);
    }
  };
  const eventWheel = {
    posterItems: eventPosterItems,
    BlockCategoryItem: _start_block_category.ReactComponent,
    Carusel: _carousel.default,
    backgroundColor: "rgba(252, 234, 181, 0.51)",
    color: "#FEE65A",
    borderColor: '#E3C434',
    onFrontPosterChange: () => null,
    isRemovable: false,
    onRemoveFrame: () => null
  };
  const lookWheel = {
    posterItems: lookPosterItems,
    BlockCategoryItem: _look_block_category.ReactComponent,
    Carusel: _carousel.default,
    backgroundColor: "rgba(231, 202, 225, 0.503)",
    color: "#BF7FB7",
    borderColor: '#A05C9B',
    onFrontPosterChange: () => null,
    isRemovable: false,
    onRemoveFrame: () => null
  };
  const soundWheel = {
    posterItems: soundPosterItems,
    BlockCategoryItem: _sound_block_category.ReactComponent,
    Carusel: _carousel.default,
    backgroundColor: "rgba(232, 237, 170, 0.501)",
    color: "#5BBD7B",
    borderColor: '#3DA059',
    onFrontPosterChange: () => null,
    isRemovable: false,
    onRemoveFrame: () => null
  };
  (0, _react.useEffect)(() => {
    slotMachineContext.setWheels([eventWheel, lookWheel, soundWheel]);
  }, []);
  const onAddNewPoster = async () => {
    const wheelType = await _ModalState.default.setModal(/*#__PURE__*/(0, _react.createElement)(_wheelSelectorModal.default, {}), "Wheel Type");
    if (!wheelType) return;
    const wheel = wheelType === "look" ? lookWheel : soundWheel;
    slotMachineContext.addWheel(wheel);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.slotMachine,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.connectionButtonsContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_connection.default, {
        connectedCog: connectedCog,
        setConnectedCog: setConnectedCog,
        handleDisconnect: handleDisconnect,
        handleConnect: handleConnect
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.innerContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _stylesModule.default.caruselContainer,
        children: slotMachineContext.wheels.map((wheel, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_wheelFrame.default, _objectSpread(_objectSpread({}, wheel), {}, {
            onFrontPosterChange: item => slotMachineContext.onFrontPosterChange(index, item),
            onRemoveFrame: () => slotMachineContext.removeWheel(index),
            isRemovable: index > 2
          }))
        }, slotMachineContext.wheels.length.toString() + index.toString()))
      })
    }), slotMachineContext.wheels.length < 5 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.plusBtnContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_addbutton.ReactComponent, {
        className: _stylesModule.default.plusBtn,
        onClick: onAddNewPoster
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.playBtnContainer,
      children: slotMachineContext.isExecuting ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _stylesModule.default.stopBtn,
        onClick: slotMachineContext.stopExecute
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_playbutton.ReactComponent, {
        className: _stylesModule.default.playBtn,
        onClick: connectedCog ? slotMachineContext.onExecute : handleConnect
      })
    })]
  });
}